__turbopack_context__.v({
  "arrowButtonsRegion": "DiscoveryTabbedCarousel-module__NJooza__arrowButtonsRegion",
  "carouselContainer": "DiscoveryTabbedCarousel-module__NJooza__carouselContainer",
  "carouselSection": "DiscoveryTabbedCarousel-module__NJooza__carouselSection",
  "eyebrow": "DiscoveryTabbedCarousel-module__NJooza__eyebrow",
  "mobileArrowButtonsRegion": "DiscoveryTabbedCarousel-module__NJooza__mobileArrowButtonsRegion",
  "sectionTitleRegion": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleRegion",
  "sectionTitleText": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleText",
  "sectionTitleTextRegion": "DiscoveryTabbedCarousel-module__NJooza__sectionTitleTextRegion",
  "slideBody": "DiscoveryTabbedCarousel-module__NJooza__slideBody",
  "slideContent": "DiscoveryTabbedCarousel-module__NJooza__slideContent",
  "slideImage": "DiscoveryTabbedCarousel-module__NJooza__slideImage",
  "slideTestimonialCard": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialCard",
  "slideTestimonialContent": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialContent",
  "slideTestimonialDot": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialDot",
  "slideTestimonialImages": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialImages",
  "slideTestimonialSource": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialSource",
  "slideTestimonialStat": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStat",
  "slideTestimonialStatDescription": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStatDescription",
  "slideTestimonialStatValue": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStatValue",
  "slideTestimonialStats": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialStats",
  "slideTestimonialTextList": "DiscoveryTabbedCarousel-module__NJooza__slideTestimonialTextList",
  "slideTitleBlock": "DiscoveryTabbedCarousel-module__NJooza__slideTitleBlock",
  "slideTitleRegion": "DiscoveryTabbedCarousel-module__NJooza__slideTitleRegion",
  "slideTitleSection": "DiscoveryTabbedCarousel-module__NJooza__slideTitleSection",
  "slideTitleText": "DiscoveryTabbedCarousel-module__NJooza__slideTitleText",
  "subtitle": "DiscoveryTabbedCarousel-module__NJooza__subtitle",
  "tabButtons": "DiscoveryTabbedCarousel-module__NJooza__tabButtons",
});
